/* eslint-disable sort-imports */
/* eslint-disable camelcase */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-param-reassign */

class devicesTabs {
  constructor(node) {
    this.block = node;

    this.selectors = {
      tabs: '.b-device-details-tabs__tabs',
      tab: '.b-device-details-tabs__tab',
      dropdown: '.b-device-details-tabs__tabs-select',
      tabsWrap: '.b-device-details-tabs__tabs-wrap',
      body: '.b-device-details-tabs__body',
      content: '.b-device-details-tabs__content',

    };

    this.classes = {
      tabActive: 'b-device-details-tabs__tab--selected',
      tabWrap: 'b-device-details-tabs__tabs-wrap',
      tab: 'b-device-details-tabs__tab',
      contentHidden: 'b-device-details-tabs__content--hidden',
    };

    this.currentIndex = 0;
    this.autoCycleStarted = false;

    if (!this.block) {
      return;
    }

    this.bootstrap();
  }

  bootstrap() {
    this.bindScrollEvent();
    this.addTabClickListener();
    this.anchorInit();
    this.tabsDropdown();
  }

  bindScrollEvent() {
    const checkVisibility = () => {
      const rect = this.block.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
    };

    window.addEventListener('scroll', checkVisibility);

    // Initial check in case the element is already in view
    checkVisibility();
  }

  // Select tab based on hash
  anchorInit() {
    const hash = location.hash.replace('#', '');
    const tabs = [ ...this.block.querySelectorAll(this.selectors.tab) ];

    if (hash) {
      tabs.forEach(tab => {
        const { slug } = tab.dataset;

        if (slug === hash) {
          tab.click();
        }
      });
    }
  }

  addTabClickListener() {
    const tabs = [ ...this.block.querySelectorAll(this.selectors.tab) ];

    tabs.forEach(tab => {
      tab.addEventListener('click', event => {
        event.preventDefault();

        // Get the data-slug of the clicked tab
        const { slug } = tab.dataset;

        // Update tab and content selection
        this.updateTabSelection(tab);
        this.updateContentSelection(slug);

        // Update URL's hash
        // window.location.hash = `#${slug}`;


        // Update currentIndex
        this.currentIndex = tabs.indexOf(tab);
      });
    });
  }

  updateTabSelection(selectedTab) {
    const tabs = [ ...this.block.querySelectorAll(this.selectors.tab) ];

    tabs.forEach(tab => {
      tab.classList.remove(this.classes.tabActive);
    });

    selectedTab.classList.add(this.classes.tabActive);
  }

  updateContentSelection(slug) {
    const contents = [ ...this.block.querySelectorAll(this.selectors.content) ];

    contents.forEach(content => {
      content.classList.remove(this.classes.contentHidden);
      if (content.dataset.slug === slug) {
        content.classList.remove(this.classes.contentHidden);
        // content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.classList.add(this.classes.contentHidden);
        // content.style.maxHeight = null
      }
    });
  }

  tabsDropdown() {
    if (window.innerWidth >= 768) return;

    const dropdown = this.block.querySelector(this.selectors.dropdown);
    const tabs = this.block.querySelectorAll(this.selectors.tab);
    const tabsWrap = this.block.querySelector(this.selectors.tabsWrap);
    let activeTab = this.block.querySelector('.b-device-details-tabs__tab--selected');

    function toggleTabs(e) {
      dropdown.classList.toggle('opened');
      tabsWrap.classList.toggle('opened');

      activeTab = e.target;
      setACtiveTabToDropdown(activeTab);
    }

    function setACtiveTabToDropdown(activeTab) {
      dropdown.textContent = activeTab.textContent;
    }

    setACtiveTabToDropdown(activeTab);

    dropdown.addEventListener('click', toggleTabs);

    tabs.forEach(tab => {
      tab.addEventListener('click', toggleTabs);
    });
  }
}
export default class deviceDetailsTabs {
  constructor() {
    this.selector = '.b-device-details-tabs';
  }

  bootstrap() {
    const nodes = document.querySelectorAll(this.selector);

    nodes.forEach(node => new devicesTabs(node));
  }
}
